module.exports = __webpack_public_path__ + "img/stocktake_counted.da311496.png";